// 관리자 매출관리 API 래퍼.
// 완료(수령완료) 주문만 매출로 집계한다. from/to 는 KST 날짜(YYYY-MM-DD, 둘 다 포함), 생략 시 전체.

import type { SalesOrderDto } from "@oo/shared";
import { api } from "@/api/client.ts";

// 완료 주문 목록 조회. range 미지정이면 전체 완료 주문.
export async function listSales(range?: {
  from?: string;
  to?: string;
}): Promise<SalesOrderDto[]> {
  const params = new URLSearchParams();
  if (range?.from) params.set("from", range.from);
  if (range?.to) params.set("to", range.to);
  const qs = params.toString();
  const data = await api.get<{ orders: SalesOrderDto[] }>(
    `/admin/stats/sales${qs ? `?${qs}` : ""}`,
  );
  return data.orders;
}
